const { $ } = window
const $body = $(document.body)

export default {
   init() {
      console.log('home')
      $('a.sbi_photo').click(e => {
         //console.log(e)
         //e.preventDefault()
      })
   },
   finalize() {
   }
}